import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, MenuListItem, IconCheck } from 'cdk-radial';
import PricingPlanSection from './PricingPlansSection';
import './PricingPlanContainer.scss';
import OrderAPIStepperFooter from '../StepperFooter/OrderAPIStepperFooter';
import styled from 'styled-components';
import { ORDER_APIS_STEPPER_FOOTER } from '../../../../../constants/APIDirectoryConstants';
import { Constants } from '../../../../../constants/constants';

const StyledIconCheck = styled(IconCheck)`
  fill: white;
  background-color: #196fe1;
  border-radius: 20px;
`;

export default function PricingPlanContainer({ setActiveStep, activeStep }) {
  const state = useSelector((state) => state);
  const cart = state?.orderAPISlice?.cart;
  const selectedApiPricing = state?.orderAPISlice?.selectedApiPricing;
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const pricingplans =
    selectedApiPricing && Object.keys(selectedApiPricing).length;
  const cartapis = cart?.length;
  const [selectedAPI, setSelectedAPI] = useState(cart[0].apiId);
  const [selectedAPIPlans, setSelectedAPIPlans] = useState(
    cart[0]?.details?.plans
  );

  const handleAPISelection = (api) => {
    setSelectedAPI(api?.apiId);
    setSelectedAPIPlans(api?.details?.plans);
  };

  useEffect(() => {
    if (pricingplans === cartapis) {
      setIsContinueDisabled(false);
    } else {
      setIsContinueDisabled(true);
    }
  }, [selectedApiPricing]);

  return (
    <Card className="pricing-selection-card">
      <div className="pricing-title-div">
        <span>{Constants.PRICING}</span>
        <span className="pricing-title-desc">{Constants.PRICING_TEXT}</span>
      </div>
      <div>
        <div className="pricing-container-card">
          <div className="pricing-container">
            <div className="api-section-div">
              <div className="api-section-title">API Name</div>
              <div className="api-section">
                {!!cart?.length &&
                  cart.map((api, index) => (
                    <div
                      key={index}
                      className={
                        selectedAPI === api?.apiId
                          ? 'selected-api'
                          : 'unselected-api'
                      }
                    >
                      {selectedApiPricing &&
                        Object.keys(selectedApiPricing).some(
                          (key) => key === api.apiId
                        ) && <StyledIconCheck />}
                      <MenuListItem
                        onClick={() => handleAPISelection(api)}
                        dataTestId="menu-list-item"
                        hideSelectedItemCheckmark={true}
                        className="api-name-item"
                      >
                        <div>
                          <div
                            className={
                              selectedAPI === api.apiId
                                ? 'selected-api-name-item'
                                : 'unselected-api-name-item'
                            }
                          >
                            <div>{api?.details?.name}</div>
                          </div>
                        </div>
                      </MenuListItem>
                    </div>
                  ))}
              </div>
            </div>

            <PricingPlanSection
              plans={selectedAPIPlans}
              selectedAPI={selectedAPI}
            />
          </div>
        </div>
      </div>
      <div className="order-api-stepper-footer">
        <OrderAPIStepperFooter
          setActiveStep={setActiveStep}
          activeStep={activeStep}
          isContinueDisabled={isContinueDisabled}
          step={ORDER_APIS_STEPPER_FOOTER.SELECTED_PRICING}
        />
      </div>
    </Card>
  );
}
